import { withEmptyOption } from '@app/modules/social-export/components/helpers/SelectOptions';
import { SelectElementWithLoading } from '@app/modules/social-export/components/inputs/SelectElementWithLoading';
import {
  SocialExportYoutubeCategoryDto,
  useSocialExportGetYoutubeCategories,
} from '@mi-front/api-v2';
import { FormattedMessage } from 'react-intl';

type Props = {
  connectionId: string;
};

/**
 * YouTube category select backed by connection-scoped categories.
 */
export function YoutubeCategoryField({ connectionId }: Props) {
  const categoriesQuery = useSocialExportGetYoutubeCategories(connectionId, {
    query: { enabled: !!connectionId },
  });

  const categoryOptions =
    categoriesQuery.data?.map((category: SocialExportYoutubeCategoryDto) => ({
      id: category.id,
      label: category.title,
    })) ?? [];

  const options = withEmptyOption(categoryOptions);

  return (
    <SelectElementWithLoading
      name="categoryId"
      label={<FormattedMessage id="socialExport.youtube.category" defaultMessage="Categoría" />}
      options={options}
      fullWidth
      isLoading={categoriesQuery.isLoading}
    />
  );
}
